const locale = {
  BANNER_TEXT: 'Read-only admin view of {{company}}',
  BANNER_TEXT_NO_COMPANY: 'Read-only admin view',
  EXIT: 'Exit',
  SESSION_EXPIRED: 'Read-only session expired',
};

export default locale;
